import { render, staticRenderFns } from "./login-precifique.view.step.0.html?vue&type=template&id=6848136c&"
import script from "./login-precifique.step.0.vue?vue&type=script&lang=ts&"
export * from "./login-precifique.step.0.vue?vue&type=script&lang=ts&"
import style0 from "./login-precifique.view.step.0.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports